module.exports = __webpack_public_path__ + "static/media/emoji-sad-svgrepo-com (1).9f489f76.svg";